import axios from 'axios';

interface ConnectionStatus {
  isConnected: boolean;
  botUsername?: string;
}

const telegramService = {
  getConnectionStatus: async (): Promise<ConnectionStatus> => {
    const response = await axios.get<ConnectionStatus>('/api/telegram/status');
    return response.data;
  },

  generatePairingCode: async (): Promise<string> => {
    const response = await axios.get<{ code: string }>('/api/telegram/pairing-code');
    return response.data.code;
  },

  disconnect: async (): Promise<void> => {
    await axios.post('/api/telegram/disconnect');
  }
};

export default telegramService; 